
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.45 8A22.48 22.48 0 008 30.46a22.35 22.35 0 006.53 15.81 22.37 22.37 0 0015.92 6.66A22.47 22.47 0 0052.9 30.48 22.48 22.48 0 0030.45 8zm0 2a20.32 20.32 0 0113.71 5.33L15.31 44.16A20.34 20.34 0 0110 30.46 20.48 20.48 0 0130.45 10zm0 40.91a20.33 20.33 0 01-13.75-5.34l28.86-28.83a20.33 20.33 0 015.32 13.72 20.47 20.47 0 01-20.43 20.47v-.02z"}})])
          )
        }
      }
    